module.exports = __webpack_public_path__ + "static/media/ue3.8e064340.png";